/* eslint-disable jsx-a11y/anchor-is-valid */

import {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {KTIcon} from '../../../helpers'
import './Category.css'
import {homeListCategoryTree} from '../../../../app/modules/auth/core/_requests'
import {AxiosError} from 'axios'
import {useLang} from '../../../i18n/Metronici18n'
import {useIntl} from 'react-intl'

/*const list = [
  {
    id: 0,
    courseTitle: 'Pysical Events',
    lessons: [
      {
        id: 0,
        name: 'Electric',
        numberOfCircuits: 9,
      },
      {
        id: 1,
        name: 'Light',
        numberOfCircuits: 3,
      },
      {
        id: 2,
        name: 'Power',
        numberOfCircuits: 2,
      },
      {
        id: 3,
        name: 'Simple Machines',
        numberOfCircuits: 4,
      },
    ],
  },
  {
    id: 1,
    courseTitle: 'Screatures and Life',
    lessons: [
      {
        id: 0,
        name: 'Systems',
        numberOfCircuits: 9,
      },
      {
        id: 1,
        name: 'Cell',
        numberOfCircuits: 3,
      },
    ],
  },
  {
    id: 2,
    courseTitle: 'Matter and Nature',
    lessons: [
      {
        id: 0,
        name: 'Matter and Heat',
        numberOfCircuits: 1,
      },
    ],
  },
  {
    id: 3,
    courseTitle: 'Fun Science',
    lessons: [
      {
        id: 0,
        name: 'Electric',
        numberOfCircuits: 1,
      },
      {
        id: 2,
        name: 'Light',
        numberOfCircuits: 1,
      },
    ],
  },
]*/

function Category() {
  const [categoryTitleList, setCategoryTitleList] = useState<any[]>([])
  const [categoryList, setCategoryList] = useState<any[]>([])
  const [categoryListNames, setCategoryListNames] = useState<any[]>([])
  const [selectCategory, setSelectCategory] = useState(0)
  const [categoryPaths, setCategoryPaths] = useState<string[]>([])

  const intl = useIntl()
  const lang = useLang()

  const getList = async () => {
    try {
      const {data} = await homeListCategoryTree(true, 0, 0, '', lang, '', '')
      setCategoryTitleList([data[0]])
      setCategoryList(data[selectCategory] ? data[selectCategory].subList : null)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }

  const getListName = async () => {
    try {
      const {data} = await homeListCategoryTree(true, 0, 0, '', 'en', '', '')
      setCategoryListNames(data[selectCategory] ? data[selectCategory].subList : null)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }

  useEffect(() => {
    getList()
    getListName()
  }, [selectCategory])

  const getRandomColorClass = (index: number) => {
    const colors = ['bg-primary', 'bg-success', 'bg-danger', 'bg-warning', 'bg-info', 'bg-dark']
    const colorIndex = index % colors.length
    return colors[colorIndex]
  }

  function convertToEnglishChars(str: string) {
    const turkishChars: {[key: string]: string} = {
      ı: 'i',
      ğ: 'g',
      ü: 'u',
      ş: 's',
      ö: 'o',
      ç: 'c',
      İ: 'I',
      Ğ: 'G',
      Ü: 'U',
      Ş: 'S',
      Ö: 'O',
      Ç: 'C',
    }

    return str.replace(/[^A-Za-z0-9_-]/g, (char) => {
      return turkishChars[char] || ''
    })
  }

  function generateCategoryPaths(data: any) {
    const paths: any = []

    function traverse(node: any, prefix = '') {
      const path = `${prefix}/${convertToEnglishChars(
        node.nodeAd.toLowerCase().replace(/\s/g, '-')
      )}`

      if (node.subList) {
        node.subList.forEach((subNode: any) => {
          const subPath = `${path}/${convertToEnglishChars(
            subNode.nodeAd.toLowerCase().replace(/\s/g, '-')
          )}`

          if ((subPath.match(/\//g) || []).length > 2) {
            paths.push(path)
          }

          traverse(subNode, path)
        })
      }
    }
    traverse(data)
    return paths
  }

  useEffect(() => {
    if (categoryListNames.length) {
      const allCateogyrPaths: string[] = []
      categoryListNames.forEach((category: any) => {
        const categoryPaths = generateCategoryPaths(category)
        allCateogyrPaths.push(...categoryPaths)
      })

      setCategoryPaths(Array.from(new Set(allCateogyrPaths)))
    }
  }, [categoryListNames])

  return (
    <div
      id='kt_category'
      className='bg-body'
      data-kt-drawer='true'
      data-kt-drawer-name='category'
      data-kt-drawer-activate='true'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'100%', 'lg': '900px'}"
      data-kt-drawer-direction='end'
      data-kt-drawer-toggle='#kt_category_toggle'
      data-kt-drawer-close='#kt_category_close'
    >
      <div className='card shadow-none rounded-0' style={{width: '100%'}}>
        <div className='card-header' id='kt_category_header'>
          <h3 className='card-title fw-bolder text-dark'>
            {intl.formatMessage({id: 'CATEGORYPAGE.TITLE'})}
          </h3>

          <div className='card-toolbar'>
            <button
              type='button'
              className='btn btn-sm btn-icon btn-active-light-primary me-n5'
              id='kt_category_close'
            >
              <KTIcon iconName='cross' className='fs-2qx' />
            </button>
          </div>
        </div>

        <div
          className='card-header mt-5 pe-5'
          style={{minHeight: '200px !important'}}
          id='kt_category_header'
        >
          <ul className='nav nav-pills nav-pills-custom mb-3 d-flex  w-100' role='tablist'>
            {categoryTitleList &&
              categoryTitleList.map((item: any, index: number) => {
                return (
                  <li key={index} className='nav-item mb-3' role='presentation'>
                    <a
                      className={`${
                        selectCategory === 0 && 'active'
                      }  sensor_link nav-link btn btn-outline btn-flex btn-color-muted btn-active-primary flex-column overflow-hidden w-50px w-xl-80px h-50px h-xl-85px pt-4 pt-xl-5 pb-2`}
                      id='sensor_tab_link_1'
                      data-bs-toggle='pill'
                      href='#sensor_tab_1'
                      aria-selected='true'
                      role='tab'
                      onClick={() => setSelectCategory(0)}
                    >
                      <span className={`sensor_name fw-bold fs-8 fs-xl-4`}>
                        {item.nodeAd === 'By Science Field' ? 'Science Lab' : item.nodeAd}
                      </span>
                    </a>
                  </li>
                )
              })}

            {/*}
            <li className='nav-item mb-3' role='presentation'>
              <a
                className=' sensor_link nav-link btn btn-outline btn-flex btn-color-muted btn-active-primary flex-column overflow-hidden w-50px w-xl-80px h-50px h-xl-85px pt-4 pt-xl-5 pb-2'
                id='sensor_tab_link_1'
                data-bs-toggle='pill'
                href='#sensor_tab_1'
                aria-selected='true'
                role='tab'
                onClick={() => setSelectCategory(2)}
              >
                <span className='sensor_name fw-bold fs-8 fs-xl-4'>Math Lab</span>
              </a>
            </li>
              {*/}
          </ul>
        </div>
        <div className='card-body position-relative bg-light' id='kt_category_body'>
          <div
            id='kt_category_scroll'
            className='position-relative scroll-y '
            data-kt-scroll='true'
            data-kt-scroll-height='auto'
            data-kt-scroll-wrappers='#kt_category_body'
            data-kt-scroll-dependencies='#kt_category_header'
            data-kt-scroll-offset='5px'
            style={{overflowX: 'hidden'}}
          >
            <div className='row g-5'>
              {/* */}
              {categoryList &&
                categoryList.map((item: any, index: number) => {
                  return (
                    <div key={index} className='col-xl-6'>
                      <div className='card card-flush h-md-100'>
                        <div className='card-header'>
                          <div className='card-title'>{item.nodeAd}</div>
                        </div>
                        <div className='card-body pt-0'>
                          <div className='table-responsive'>
                            <table className='table table-row-dashed align-middle gs-0 gy-4 my-0'>
                              {/*}
                            <thead>
                              <tr className='fs-7 fw-bold text-gray-500 border-bottom-0'>
                                <th className='p-0 w-250px w-xxl-450px'></th>
                                <th className='p-0 min-w-50px text-end'></th>
                              </tr>
                            </thead>
                */}
                              <tbody>
                                {item?.subList.map((lesson: any, index2: number) => {
                                  return (
                                    <tr key={index2}>
                                      <td>
                                        <div className='d-flex align-items-center'>
                                          <div className='symbol symbol-40px me-4'>
                                            <div
                                              className={`symbol-label fs-2 fw-semibold ${getRandomColorClass(
                                                index2
                                              )} text-inverse-danger`}
                                            >
                                              {lesson.nodeAd.charAt(0)}
                                            </div>
                                          </div>
                                          <div className='d-flex justify-content-start flex-column'>
                                            <Link
                                              to={`units${
                                                categoryPaths.filter((path) =>
                                                  path.includes(
                                                    convertToEnglishChars(
                                                      //  item.nodeAd.toLowerCase().replace(/\s/g, '-')
                                                      categoryListNames[index].nodeAd
                                                        .toLowerCase()
                                                        .replace(/\s/g, '-')
                                                    )
                                                  )
                                                )[index2]
                                              }`}
                                              state={{
                                                path: `units${
                                                  categoryPaths.filter((path) =>
                                                    path.includes(
                                                      convertToEnglishChars(
                                                        /*  item.nodeAd
                                                          .toLowerCase()
                                                          .replace(/\s/g, '-')*/
                                                        categoryListNames[index].nodeAd
                                                          .toLowerCase()
                                                          .replace(/\s/g, '-')
                                                      )
                                                    )
                                                  )[index2]
                                                }`,
                                              }}
                                              className='text-dark fw-bold text-hover-primary mb-1 fs-6'
                                            >
                                              {lesson.nodeAd}
                                            </Link>
                                            <span className='text-muted fw-semibold d-block fs-7'>
                                              {lesson.subList.length}{' '}
                                              {intl.formatMessage({id: 'CATEGORYPAGE.LESSONS'})}
                                            </span>
                                          </div>
                                        </div>
                                      </td>

                                      <td className='text-end'>
                                        <Link
                                          to={`units${
                                            categoryPaths.filter((path) =>
                                              path.includes(
                                                convertToEnglishChars(
                                                  // item.nodeAd.toLowerCase().replace(/\s/g, '-')
                                                  categoryListNames[index].nodeAd
                                                    .toLowerCase()
                                                    .replace(/\s/g, '-')
                                                )
                                              )
                                            )[index2]
                                          }`}
                                          state={{
                                            path: `units${
                                              categoryPaths.filter((path) =>
                                                path.includes(
                                                  convertToEnglishChars(
                                                    //    item.nodeAd.toLowerCase().replace(/\s/g, '-')
                                                    categoryListNames[index].nodeAd
                                                      .toLowerCase()
                                                      .replace(/\s/g, '-')
                                                  )
                                                )
                                              )[index2]
                                            }`,
                                          }}
                                          className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary w-30px h-30px'
                                        >
                                          <i className='ki-outline ki-arrow-right fs-2'></i>
                                        </Link>
                                      </td>
                                    </tr>
                                  )
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })}

              {/* */}
              {/* }
              {list.map((item: any, index: number) => {
                return (
                  <div key={index} className='col-xl-6'>
                    <div className='card card-flush h-md-100'>
                      <div className='card-header'>
                        <div className='card-title'>{item.courseTitle}</div>
                      </div>
                      <div className='card-body pt-0'>
                        <div className='table-responsive'>
                          <table className='table table-row-dashed align-middle gs-0 gy-4 my-0'>
           
                            <tbody>
                              {item.lessons.map((lesson: any, index: number) => {
                                return (
                                  <tr key={index}>
                                    <td>
                                      <div className='d-flex align-items-center'>
                                        <div className='symbol symbol-40px me-4'>
                                          <div
                                            className={`symbol-label fs-2 fw-semibold ${getRandomColorClass(
                                              index
                                            )} text-inverse-danger`}
                                          >
                                            {lesson.name.charAt(0)}
                                          </div>
                                        </div>
                                        <div className='d-flex justify-content-start flex-column'>
                                          <a
                                            href='#'
                                            className='text-dark fw-bold text-hover-primary mb-1 fs-6'
                                          >
                                            {lesson.name}
                                          </a>
                                          <span className='text-muted fw-semibold d-block fs-7'>
                                            {lesson.numberOfCircuits} experiments
                                          </span>
                                        </div>
                                      </div>
                                    </td>

                                    <td className='text-end'>
                                      <Link
                                        to={'selectCategory'}
                                        className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary w-30px h-30px'
                                      >
                                        <i className='ki-outline ki-arrow-right fs-2'></i>
                                      </Link>
                                    </td>
                                  </tr>
                                )
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })}

              {/* */}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Category
